export const DUCUMENT_ANEXO = 'A';
export const documentOptions = [
  {
    value: 'C',
    label: 'Contrato',
    selected: true,
  },
  {
    value: 'A',
    label: 'Anexos',
    selected: true,
  },
  {
    value: 'K',
    label: 'KYC',
    selected: true,
  },
  {
    value: 'P',
    label: 'Perfil',
    selected: true,
  },
  {
    value: 'M',
    label: 'MGA',
    selected: true,
  },
];
